import WorkingDayType from 'modules/contracts/store/models/WorkingDayType'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class WorkingDayTypes extends PayrollLegalEntityResource<WorkingDayType> {
  get cacheKey(): string {
    return 'workingDayTypes'
  }

  model() {
    return WorkingDayType
  }
}

export { WorkingDayTypes }
